import { readonly, ref } from 'vue'

export type FeedbackDrawerView = 'form' | 'success' | 'list' | 'thread'

const visible = ref(false)
const view = ref<FeedbackDrawerView>('form')
const activeTicketId = ref<string>('')
const lastTicketNo = ref('')
const lastTicketId = ref<string>('')

export function openFeedbackDrawer(options?: { view?: FeedbackDrawerView; ticketId?: string }) {
  view.value = options?.view || 'form'
  activeTicketId.value = options?.ticketId || ''
  visible.value = true
}

export function closeFeedbackDrawer() {
  visible.value = false
}

export function useFeedbackDrawer() {
  return {
    visible,
    view,
    activeTicketId,
    lastTicketNo: readonly(lastTicketNo),
    lastTicketId: readonly(lastTicketId),
    open: openFeedbackDrawer,
    close: closeFeedbackDrawer,
    setSuccess(ticketId: string, ticketNo: string) {
      lastTicketId.value = ticketId
      lastTicketNo.value = ticketNo
      activeTicketId.value = ticketId
      view.value = 'success'
    },
    showList() {
      view.value = 'list'
      activeTicketId.value = ''
    },
    showThread(ticketId: string) {
      activeTicketId.value = ticketId
      view.value = 'thread'
    },
    showForm() {
      view.value = 'form'
      activeTicketId.value = ''
    }
  }
}
